import Typography from "@mui/material/Typography";


import { useMsal } from "@azure/msal-react";
import { useState, useEffect } from "react";



export const WelcomeName = () => {
const [userName, setUserName] = useState('');
const { instance } = useMsal();

useEffect(() => {
  const currentAccount = instance.getActiveAccount();

if(currentAccount)
{
  setUserName(currentAccount.name);
}

}, [instance]);

    return <Typography variant="h6" sx={{paddingRight: '10px', paddingTop:'3px'}}> Welcome, {userName}</Typography>;
};